import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useHlyGrafStore = create(
  persist(
    set => ({
      windowDays: 1,
      alignEnd: true,
      isAktual: false,
      activeTab: 'graf',
      chartFormat: 'png',
      interactive: false,

      setWindowDays: windowDays => set({ windowDays }),
      setAlignEnd: alignEnd => set({ alignEnd }),
      setIsAktual: isAktual => set({ isAktual }),
      setActiveTab: activeTab => set({ activeTab }),
      setChartFormat: chartFormat => set({ chartFormat }),
      setInteractive: interactive => set({ interactive }),
    }),
    {
      name: 'hly-graf-store',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
